import { cn } from '@/lib/utils'
import { IconCircleCheckFilled } from '@tabler/icons-react'
import type { QuizOption } from '@/content/quiz/types'

interface OptionButtonProps {
  option: QuizOption
  selected?: boolean
  onClick: () => void
  className?: string
  variant?: 'radio' | 'checkbox' | 'large'
}

export function OptionButton({
  option,
  selected,
  onClick,
  className,
  variant = 'radio',
}: OptionButtonProps) {
  const hasImage = !!option.image
  const hasLabel = !!option.label

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'w-full text-left rounded-xl border-2 transition-all flex items-center gap-4 px-6 py-5',
        variant === 'large' && 'rounded-2xl text-center p-6 min-h-[80px]',
        selected
          ? 'border-sky-200 bg-sky-100'
          : 'border-slate-200/60 hover:border-slate-300/60 bg-white',
        className
      )}
    >
      {hasImage && (
        <img
          src={option.image}
          alt={option.label || option.value}
          className={cn(
            'object-cover rounded-lg flex-shrink-0',
            variant === 'large' ? 'w-16 h-16' : 'w-12 h-12'
          )}
        />
      )}
      {hasLabel && (
        <span className={cn(
          'flex-1 font-medium',
          variant === 'large' ? 'text-lg' : 'text-base',
          selected ? 'text-sky-600' : 'text-slate-600'
        )}>
          {option.label}
        </span>
      )}
      {variant !== 'large' && (hasImage || hasLabel) && (
        <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center">
          {selected ? (
            <IconCircleCheckFilled className="w-6 h-6 text-sky-500" />
          ) : (
            <div className="w-5 h-5 rounded-full border-2 border-slate-200" />
          )}
        </div>
      )}
    </button>
  )
}
